import React from 'react'

const P65Warning = (props) => {
    return (
        <div className='osePropsModal'>
            <div class="modal fade c-modal show" id="prop65" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel"  aria-modal="true" role="dialog">
                <div class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down">
                    <div class="modal-content">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div class="modal-body">
                            <div class="prop65Div">
                                {props.isCart == true?<p><b>{props && props.message && props.message.head ? props.message.head : ""}</b></p>:
                                <h3 class="modal-title mb-4 fwb oseHead">
                                   {props && props.message && props.message.head ? props.message.head : ""}
                                </h3>}
                                <div class="d-flex mb-4 oseDescription">
                                    <img src={props && props.message && props.message.icon ?props.message.icon : ""} class="prop65-restrictions-icon me-2" />
                                    <div class="desc-prop65 osePropsMessage" dangerouslySetInnerHTML={{__html : props && props.message && props.message.description ?props.message.description : ""}}></div>
                                </div>
                                <div>
                                    <button type="button" class="btn btn-ose-primary" data-bs-dismiss="modal">CLOSE WINDOW</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default P65Warning